
import * as React from "react";

import { ProcessDocumentationView } from "processEditor/components/Documentation/ProcessDocumentationView";
import { useDispatch, useSelector } from "react-redux";
import { State } from "processEditor/model/State";
import { Process } from "processEditor/model/Process";
import { updateProcessDocumentation } from "processEditor/actions/UpdateProcessDocumentation";
import { IElementDictionary, ISubProcessData, ITaskData } from "processEditor/model/IProcessData";
import { HashMap, arrayToHashMap } from "shared/model/HashMap";

export const ProcessDocumentationViewWrapper: React.FC = () => {

    const { process, elementParamters, tasks, subprocesses } =
        useSelector<State, { process: Process, elementParamters: IElementDictionary, tasks: HashMap<ITaskData>, subprocesses: HashMap<ISubProcessData> }>((state) => {
            return {
                process: state.process,
                elementParamters: state.elements,
                tasks: arrayToHashMap(state.tasks, "uri"),
                subprocesses: arrayToHashMap(state.subProcesses, "uniqueIdentifier")
            }
        });

    const dispatch = useDispatch();
    const handleAcceptChanges = (documentation: string) => {
        // We only allow saving the documentation with process if the process is new.
        if (process.uniqueIdentifier == null) {
            dispatch(updateProcessDocumentation(documentation));
        }
    }
    return <ProcessDocumentationView
        uniqueIdentifier={process.uniqueIdentifier}
        name={process.name}
        majorVersion={process.majorVersion || 0}
        minorVersion={process.minorVersion || 1}
        isSubprocess={process.isSubprocess || false}
        processId={process.id}
        isTemplate={false}
        onAcceptChangesClick={handleAcceptChanges}
        initialContext={{ bpmnXml: process.bpmn, elementParameters: elementParamters, tasks: tasks, subprocesses: subprocesses }}
    />
}


